import { http } from '@/app/helpers/axios-instance';

export const fetchInstanceInfo = () =>
  http.get(`/v1/instance/support/info`).then(response => response.data);